import styled from '@emotion/styled';
import { TableCell } from '@mui/material';

export const Cell = styled(TableCell)`
  max-width: 150px;
`;

export const TableCellDiv = styled.div`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
